var scope_0 = require('/Users/scottfairgrieve/git/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31d175d6824ade86c029de899b1c8b79.js').default;
var scope_1 = require('/Users/scottfairgrieve/git/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ac80d3b12a8d1698df68988247d794b3.js').default;
var scope_2 = require('/Users/scottfairgrieve/git/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c261c188655d3019000faf8dbf58c27a.js').default;
var scope_3 = require('/Users/scottfairgrieve/git/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    